<template>
  <div class="footer">
    Copyright © 2022-2022 Shanghai JG Energy, Inc. All Rights Reserved. 沪ICP备2022027882号
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
text-align: center;
font-size: 1.2em;
}
</style>
